module.exports = __webpack_public_path__ + "static/media/perfil_leonor.ab581208.png";